jQuery( function ( $ ) {

    $( 'section.related.products' ).each( function () {

        const $section = $(this);
        const $slider = $( '.product-list', $section );
        const $arrows = $( '.left-btn, .right-btn', $section );

        $slider.on( 'init afterChange', function ( e, slick, index = null ) {
            // slick calls a11y functionality before afterChange
            // we want to remove the slide's tabindex, so we need to disable the a11y option and call it's core function ourselves
            slick.initADA();
            slick.$slides.filter( '.slick-active' ).removeAttr( 'tabindex' );
            // $arrows.each( function () {
            //     $(this).attr( 'tabindex', $(this).hasClass( 'slick-disabled' ) ? -1 : 0 );
            // });
        });

        $slider.slick({
            infinite: false,
            dots: false,
            arrows: true,
            prevArrow: $( '.left-btn', $section ),
            nextArrow: $( '.right-btn', $section ),
            accessibility: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: ThemeJS.Variables.Screen_Sizes.sm,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: ThemeJS.Variables.Screen_Sizes.md,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: ThemeJS.Variables.Screen_Sizes.xl,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                },
            ]
        });
    
    });

});